'use client';
/**
 * search_unify1 A — 검색창 한 벌(kd-gs)을 헤더 밖 자리(홈 히어로 lg · /search · 지역 허브)에 꽂는 자리.
 *   서버 HTML·첫 수화 = NavSearchShell 의 SearchShellDesktop(GlobalSearch 닫힌 상태와 같은 마크업 — JS 0 에서도 GET /search).
 *   첫 포커스에서 GlobalSearch 를 불러와 넘겨준다(헤더 SearchSlotBody 와 같은 수법 · 친 글자 인계) — 자동완성·로직은 헤더와 같다.
 * ⛔ 방문자 분기 없음. src 는 로깅용(header·hero·search·hub).
 */
import React from 'react'; // vitest(클래식 JSX) 렌더 검증용
import { useCallback, useState, type ComponentType } from 'react';
import type { GlobalSearchProps } from '@/components/nav/GlobalSearch';
import { SearchShellDesktop, type SearchArm, type SearchSize, type SearchSrc } from '@/components/nav/NavSearchShell';
import { useNavData } from '@/components/nav/nav-data-context';

const loadGlobalSearch = () => import('@/components/nav/GlobalSearch');

export interface KdSearchBoxProps { src: SearchSrc; size?: SearchSize; defaultQ?: string; className?: string }

export default function KdSearchBox({ src, size = 'md', defaultQ = '', className }: KdSearchBoxProps) {
  const { headerRegion } = useNavData();
  const [Full, setFull] = useState<ComponentType<GlobalSearchProps> | null>(null);
  const [q0, setQ0] = useState('');
  const arm = useCallback<SearchArm>((_v, input) => {
    const typed = input?.value ?? '';
    loadGlobalSearch().then((m) => { setQ0(typed); setFull(() => m.default); }).catch(() => { /* 다음 포커스에서 재시도 */ });
  }, []);
  if (!Full) return <SearchShellDesktop onArm={arm} src={src} size={size} defaultQ={defaultQ} className={className} />;
  return <Full variant="desktop" data={headerRegion} src={src} size={size} className={className} autoOpen initialQ={q0} />;
}
